<!--
 * @Author: mzw
 * @Date: 2022-03-30 14:46:01
 * @LastEditors: mzw
 * @LastEditTime: 2022-03-30 14:46:01
 * @Description: 状态tab组件
-->
<template>
  <div class="statusTabs" v-if="tabList.length > 0">
    <div>
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="
          'order-tab-item ' +
          (item[tableConfig.codeKey] === curStatus ? 'tab-item-active' : '')
        "
        @click="changeStatusHandle(item)"
      >
        {{ item[tableConfig.labelKey]
        }}<template v-if="item.nums || item.nums === 0"
          >({{ item.nums }})</template
        >
      </div>
    </div>

    <slot name="operation"></slot>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableConfig: {
      type: Object,
      default: () => {
        return {
          labelKey: 'value', // 显示状态文案的字段名
          codeKey: 'code' // 状态码的字段名
        }
      }
    },
    curStatus: {
      // 当前选中状态
      type: String
    }
  },
  methods: {
    changeStatusHandle (item) {
      this.$emit('changeStatusHandle', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.statusTabs {
  margin: 0;
  position: relative;
  height: 48px;
  border-bottom: 2px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  .order-tab-item {
    display: inline-block;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    padding: 0 25px 46px 25px;
    cursor: pointer;
  }
  // .tab-item-active{
  //   border-bottom: 2px solid #1989FA;
  // }
}
</style>
